export default __webpack_public_path__ + "static/media/sendFilled.ebf188a2.svg";